import React from 'react';

const DollarPaymentLink: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1364 2.66666C10.5234 2.66666 2.66675 10.4759 2.66675 20H0.666748C0.666748 9.3574 9.43281 0.666656 20.1364 0.666656C27.7276 0.666656 34.3444 5.01331 37.557 11.2946L35.7764 12.2054C32.8941 6.57 26.9515 2.66666 20.1364 2.66666Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8638 37.3333C29.4768 37.3333 37.3334 29.5241 37.3334 20H39.3334C39.3334 30.6426 30.5674 39.3333 19.8638 39.3333C12.2726 39.3333 5.6558 34.9867 2.44312 28.7054L4.22373 27.7946C7.10603 33.43 13.0486 37.3333 19.8638 37.3333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.7776 4.12464L36.7481 12.8111L28.8608 11.6081L29.1624 9.63095L35.0054 10.5222L35.7915 3.88925L37.7776 4.12464Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25217 27.1888L11.1394 28.3919L10.8378 30.369L4.99488 29.4778L4.20876 36.1107L2.22266 35.8753L3.25217 27.1888Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0793 8.16666L21.0793 31L19.0793 31L19.0793 8.16666L21.0793 8.16666Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0956 11.1699C21.439 11.0099 24.117 11.5846 25.5044 12.3128L26.3899 12.7775L25.4604 14.5484L24.575 14.0837C23.5641 13.5532 21.2655 13.0264 19.2318 13.1652C18.2217 13.2342 17.4022 13.4605 16.8632 13.8237C16.3801 14.1492 16.0865 14.6001 16.0865 15.3374C16.0865 16.2482 16.4727 16.8247 17.1592 17.3055C17.9126 17.8333 18.9613 18.1943 20.1866 18.5845C20.2706 18.6113 20.3557 18.6382 20.4416 18.6654C21.5299 19.0102 22.7518 19.3972 23.7051 19.9841C24.7996 20.6579 25.6798 21.6831 25.6798 23.2794C25.6798 24.677 25.1921 25.7954 24.3083 26.5935C23.4559 27.3632 22.3258 27.754 21.1642 27.9204C18.8509 28.2517 16.0431 27.7467 13.8008 26.9728L12.8555 26.6465L13.508 24.756L14.4533 25.0822C16.5282 25.7984 18.9968 26.2104 20.8806 25.9406C21.8176 25.8064 22.5161 25.5171 22.9678 25.1092C23.3881 24.7297 23.6798 24.1729 23.6798 23.2794C23.6798 22.5848 23.3608 22.1208 22.6566 21.6872C21.9223 21.2352 20.9271 20.9187 19.753 20.5453C19.6957 20.5271 19.6379 20.5087 19.5797 20.4902C18.4067 20.1167 17.057 19.6758 16.0117 18.9436C14.8994 18.1645 14.0865 17.0228 14.0865 15.3374C14.0865 13.9037 14.7373 12.8444 15.7457 12.165C16.6981 11.5234 17.9173 11.2503 19.0956 11.1699Z"
      />
    </svg>
  );
};

export default DollarPaymentLink;
